<template>
  <div style="font-size:100px">
    404
  </div>
</template>
<script>
export default {
  data () {
    return {
    }
  }
}
</script>
<style lang='less' scoped>
</style>